// import { CssBaseline, ThemeProvider } from "@mui/material";
// import useSettings from "app/hooks/useSettings";

// const AppTheme = ({children}) => {
//     const {settings} = useSettings();
//     let activeTheme = {...settings.themes[settings.activeTheme]}

//     return (
//         <ThemeProvider theme={activeTheme}>
//             <CssBaseline/>
//             {children}
//         </ThemeProvider>
//     );
// };

// export default AppTheme;
import { CssBaseline, ThemeProvider } from "@mui/material";
import useSettings from "app/hooks/useSettings";

const AppTheme = ({ children }) => {
  const { settings } = useSettings();
  const { activeTheme, themeMode, themes } = settings;

  // Determine correct theme based on mode
  const themeKey =
    themeMode === "dark" && themes[`${activeTheme}Dark`]
      ? `${activeTheme}Dark`
      : activeTheme;

  const theme = { ...themes[themeKey] };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default AppTheme;
